/**
 * Event Calendar Pro has an accessibility issue with the date toggle:
 * Visible label and accessible name do not match.
 *
 * Fix: Include current date selection in accessible name.
 *
 * Notes: This is a temporary fix until the issue is fixed in Event Calendar
 * Pro. This only works for page load; once the date is changed the
 * toggle goes back to it's default state.
 */

const dateToggle = document.querySelector(
  '.tribe-events-c-top-bar__datepicker-button'
);

if (dateToggle) {
  const beginAndEndDates = dateToggle.querySelectorAll(
    '.tribe-events-c-top-bar__datepicker-desktop'
  );

  const separator = dateToggle.querySelector(
    '.tribe-events-c-top-bar__datepicker-separator'
  );

  dateToggle.setAttribute(
    'aria-label',
    `${beginAndEndDates[0]?.innerText}${separator ? separator.innerText : ''}${
      beginAndEndDates[1] ? beginAndEndDates[1].innerText : ''
    }`
  );
}

/**
 * Short-term solution to address the ill-named series links where it defaults
 * to repeating the name of the series rather than something useful (i.e. See
 * recurring dates).
 *
 * This *should* work on the template level but is not going to be fixed until
 * a later date.
 * https://theeventscalendarsupport.zendesk.com/hc/en-us/requests/425560
 */
[
  ...document.querySelectorAll('.tribe-events-calendar-series-archive__link'),
].forEach((link) => {
  const el = link.querySelector('.tec_series_marker__title');
  if (el != null) {
    const eventName = el
      .closest('.tribe-events-calendar-list__event-header')
      ?.querySelector('.tribe-events-calendar-list__event-title');

    const eventDate = el
      .closest('.tribe-events-calendar-list__event-header')
      ?.querySelector('.tribe-events-calendar-list__event-datetime');

    el.parentElement.removeAttribute('title');
    el.parentElement.setAttribute(
      'aria-label',
      `See recurring dates for ${eventName?.innerText || ''} in addition to the one scheduled for ${eventDate?.innerText || ''}`
    );
    el.innerText = 'See recurring dates';
    el.classList.remove('tribe-common-a11y-visual-hide');
  }
});
